module.exports = __webpack_public_path__ + "a7a49f4a5515866aaac6b947faca0fea.jpg";